import Axios from 'axios';
import React, { useState } from 'react';
import { xs_languageCode, systemCode } from '../..';
import { getAllAgg } from '../utils/getAllAgg';
import { getFastBetData } from '../fetchFastbetData';
import { getConfiguration } from '../utils/configuration';
import { filterSearchResults } from '../utils/filterSearchResults';

import FastbetCartContext from './FastbetCartContext';

function FastbetConf(props) {

	
	const[fastbetCartContext, setFastbetCartContext] = useState({
		rawDataLive : null,
		rawDataPrematch : null,
		matchListPrematch : null,
		matchListLive : null,
		fullMatchList : null,
		dataLoaded : false,
		selectedMatch : null,
		matchFieldText : null,
		liveEventsByAlias : null,
		prematchEventsByAlias : null,
		matchArray : [],
		autocompleteSearchResults : [],
		betList : null,
		initialized : false,
		loading : false,
		fastbetType : getConfiguration().fbt,
		matchFocusedIndex : null, // it is the html autocomplete index of the pointed elements
		
		reload : function(callback){
			this.initialized = false;
			this.loading = false;
			setFastbetCartContext(function(prev){
				return {
					...prev,
					loading : false,
					initialized : false
				}
			});
			this.initialize(callback);
			
		},
		initialize : function(callback){
			if(this.initialized == false && this.loading == false){
				this.setLoading(true);
				getFastBetData( (data) =>{
					this.setLoading(false);
					if(data != null){
						this.setEvents(data);
						if(typeof callback === 'function'){
							callback(data);
						}
					}
				}, null);
			}
		},
		setLoading : function (value){
    		setFastbetCartContext(function(prev){
				return {
					...prev,
					loading : value
				}
			});
		},
		isLoading : function(){
			return this.loading;
		},
		isInitialized : function(){
			return this.initialized;
		},
		setMatchFocusedIndex : function (index){
			this.matchFocusedIndex = index;
    		setFastbetCartContext(function(prev){
				return {
					...prev,
					matchFocusedIndex : index
				}
			});	
		},
		getMatchFocusedIndex : function (){
			return this.matchFocusedIndex;
		},
	    setEvents : function(data){  
	    	this.initialized = true;
	    	this.rawDataLive = data.rawDataLive;
	    	this.rawDataPrematch = data.rawDataPrematch;
	    	this.matchListPrematch = data.matchListPrematch;
	    	this.matchListLive = data.matchListLive;
	    	this.fullMatchList = data.fullMatchList;
	    	this.liveEventsByAlias = data.liveEventsByAlias;
	    	this.prematchEventsByAlias = data.prematchEventsByAlias;
	    	this.matchArray = data.matchArray;
	    	this.dataLoaded = true;
    		setFastbetCartContext(function(prev){
				return {
					...prev,
					initialized : true,
			    	rawDataLive : data.rawDataLive,
		    		rawDataPrematch : data.rawDataPrematch,
		    		matchListPrematch : data.matchListPrematch,
		    		matchListLive : data.matchListLive,
		    		fullMatchList : data.fullMatchList,
		    		prematchEventsByAlias : data.prematchEventsByAlias,
		    		liveEventsByAlias : data.liveEventsByAlias,
		    		matchArray : data.matchArray,
		    		dataLoaded : true
				}
			});
	    },    	
	    getMatchList : function() {
			return this.fullMatchList;
		},
	    getMatchArray : function() {
			return this.matchArray;
		},
		getSelectedMatch : function(){
			return this.selectedMatch;
		},
		
		setSelectedMatch : function(keyMatch, callback){
//			console.log("selected index is " + keyMatch);
			let selectedMatch = this.fastbetType === 'XR'? this.fullMatchList[keyMatch] : this.autocompleteSearchResults[keyMatch];
    		if(selectedMatch != null){
    			let matchFieldText = selectedMatch.desc;
    			const aggregataTutte = getAllAgg(selectedMatch.isLive, selectedMatch.sportRef).idAggregata;
				const url = getConfiguration().api.getEvento;
	            const params = {
	                systemCode,
	                lingua: xs_languageCode,
	                hash: '',
	                pal : selectedMatch.pal,
	                avv : selectedMatch.avv,
	                idAggregata: aggregataTutte,
	                isLive : selectedMatch.isLive
	            }
	            this.fetchData(url, params,(response) => {
	            	let betList = null;
	            	if(response != null){
	            		betList = response.scs;
	            	}
	            	else{
	            		selectedMatch = null;
	            		matchFieldText = null;
	            	}
	            	if(callback){
	            		callback(betList);
	            	}
	    			// all the component has to be re-rerended
	    			setFastbetCartContext(function(prev){
	    				return {
	    					...prev,
	    					selectedMatch,
	    					matchFieldText,
	    					autocompleteSearchResults : [],
	    					betList,
	    					matchFocusedIndex : null
	    				}
	    			});   
	            });
				
 			
    		}
		},
		setMatchFieldText : function(matchFieldText){
			let autocompleteSearchResults = [];
			
			if(this.fastbetType === 'AUTOCOMPLETE'){
        		// autocomplete mode: search and show results
				if(matchFieldText && matchFieldText.length >= 3){
					autocompleteSearchResults = filterSearchResults(this.getMatchArray(), matchFieldText, 'MATCH', function(match) {
						return match.desc;
					});
				}
			}
			this.autocompleteSearchResults = autocompleteSearchResults;
			setFastbetCartContext(function(prev){
	    		return {
	    			...prev,
	    			matchFieldText,
	    			autocompleteSearchResults,
	    			matchFocusedIndex : null
	    		}
	    	});
		},
		
		getMatchFieldText : function(){
			return this.matchFieldText;
		},
		
		getAutocompleteSearchResults : function(){
			return this.autocompleteSearchResults;
		},
		
		getBetList : function(){
			return this.betList;
		},
		
		removeMatch : function (){
			setFastbetCartContext(function(prev){
				return {
					...prev,
					selectedMatch : null,
					matchFieldText : null,
					betList : null,
					autocompleteSearchResults : [],
					matchFocusedIndex : null
				}
			}); 
		},
		getRawDataLive : function(){
			return this.rawDataLive;
		},
		getRawDataPrematch : function(){
			return this.rawDataPrematch;
		},
		isDataLoaded : function(){
			return this.dataLoaded;
		},
		fetchData : async (url, params, callback) => {
            try {
                const result = await Axios.get(url, {params});
                callback(result.data);
                
            } 
            catch (error) {
                console.error('Errore ' + url + ': ' + error);
            }
        }
	});

	 
	

	
	
    return (
    	<FastbetCartContext.Provider value={fastbetCartContext}>
    	    {props.children}
    	</FastbetCartContext.Provider>
    );
}

export default FastbetConf;
